import { mapGetters } from "vuex";
import * as types from "@/store/types";

const exchangeAutoComplete = () =>
  import("@/components/ExchangeAutoComplete/index");
import { OperationService } from "@/services";
import VueQrcode from "vue-qrcode";

const TagCard = () =>
  import("@/components/OperationsPage/Withdrawal/Crypto/TagCard/index");
export default {
  name: "crypto",
  components: { exchangeAutoComplete, VueQrcode, TagCard },
  props: [],
  data() {
    return {
      tab: 0,
      fromWallet: "",
      address: "",
      loading: false,
      copyFlag: true,
      loadingFlag: false,
      dialog: true,
      currencies: [],
      networkList: [],
      networkDetails: {},
      selectedCurrency: "",
      confirmTagWarning: false,
      showTagWarningDialog: false
      // getCurrencies: [],
      // getWallets: {},
      // getExchanges: {},
      // isCurrencyLoaded: false,
      // isWalletLoaded: false,
      // isExchangeLoaded: false,
    };
  },
  computed: {
    ...mapGetters({
      // getCurrencies: types.currencies.getters.GET_CURRENCIES,
      // getWallets: types.operations.getters.GET_WALLET,
      // getExchanges: types.wallets.getters.GET_EXCHANGE_WALLETS,
      getDepositCurrencies: types.operations.getters.GET_DEPOSIT_CURRENCIES
    }),
    setCurrencies() {
      let data = [];
      if (Object.entries(this.getWallets).length > 0) {
        this.getWallets.wallets.forEach(elem => {
          if (elem.is_deposit_active && elem.currency.iso !== "IRR") {
            data.push(elem);
          }
        });
        return data;
      }
    },
    setFromCurrency() {
      let data = {};
      if (
        this.setCurrencies.length > 0 &&
        Object.entries(this.getDepositCurrencies).length > 0
      ) {
        data = this.setCurrencies.find(elem => {
          if (elem.currency.iso === this.$route.query.from) {
            return elem;
          }
        });
        if (!data) {
          this.$router.push({
            query: { from: this.getDepositCurrencies[0].currency.iso }
          });
          data = this.getDepositCurrencies[0];
        }
        return data;
      }
    }
    // setWallet() {
    //   if (Object.entries(this.getWallets).length > 0) {
    //     return this.getWallets.wallets.find((elem) => {
    //       if (elem.iso === this.$route.query.from) {
    //         return elem;
    //       }
    //     });
    //   }
    // },
    // networkList() {
    //   if (this.setWallet) {
    //     return this.setWallet.networks;
    //   }
    // },
    // setAddress() {

    // this.loadingFlag = false;
    // if(this.networkList)
    // if (this.networkList && this.setWallet) {
    //   let data = {};
    //   let active = "";
    //   let localId = this.addressId ? this.addressId : this.networkList[0].id;
    //   this.networkList.find((elem) => {
    //     if (elem.id === localId) {
    //       if (elem.is_deposit_active) {
    //         active = true;
    //       }
    //     }
    //   });

    // if (active) {
    //   // if (this.setWallet.addresses.length > 0) {
    //   //   data = this.setWallet.addresses.find(
    //   //     elem => elem.network_id === localId
    //   //   );
    //   //   if (!data) {
    //   //     this.setAddressRequest(localId);
    //   //   } else {
    //   //     this.dialog = data.address_extra ? true : false;
    //   //     this.loadingFlag = true;
    //   //     this.addressId = "";
    //   //   }
    //   // } else {
    //   //   this.setAddressRequest(localId);
    //   // }
    //   data = this.setWallet.addresses.find(
    //     (elem) => elem.network_id === localId
    //   );
    //   this.loadingFlag = true;
    //   if (!data) {
    //     return data;
    //   } else {
    //     this.dialog = data.address_extra ? true : false;
    //     this.addressId = "";
    //   }
    //   return data;
    // } else {
    //   this.addressId = "";
    //   return false;
    // }
    // }
    // }
  },
  mounted() {
    // this.getCurrenciesService();
    // this.getWalletService();
    // this.getExchangeService();
    this.getCurrencies();
  },
  // watch: {
  //   setWallet: {
  //     immediate: true,
  //     handler(newValue) {
  //       if (newValue) {
  //         this.fromWallet = newValue;
  //       }
  //     }
  //   }
  // },
  methods: {
    // ...mapActions({
    //   setWallets: types.operations.actions.SET_WALLET
    // }),
    generateAddress(network) {
      this.networkDetails = network;
      if (network.address.address_extra) {
        this.showTagWarningDialog = true;
      }
    },
    setAddressRequest() {
      this.loading = true;
      // let localId = this.addressId ? this.addressId : this.networkList[0].id;
      OperationService.setAddress(
        this.networkList.currency.id,
        this.networkDetails.id
      )
        .then(response => {
          if (response.status === 200) {
            this.updateFromCurrency(this.$route.query.from);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    setAddressNotif() {
      if (this.copyFlag) {
        this.copyFlag = false;
        this.$toast.success(this.$t("operationsPage.copyAddress"));
      } else {
        setTimeout(() => {
          this.copyFlag = true;
        }, 1500);
      }
    },

    // getCurrenciesService() {
    //   CurrenciesService.getCurrencies().then(async (response) => {
    //     this.getCurrencies = response.data.data;
    //     this.isCurrencyLoaded = true;
    //   });
    // },
    // getWalletService() {
    //   WalletService.getWalletV4().then((response) => {
    //     this.getWallets = response.data.data;
    //     this.isWalletLoaded = true;
    //   });
    // },
    // getExchangeService() {
    //   WalletService.getExchanges().then((response) => {
    //     this.getExchanges = response.data.data;
    //     this.isExchangeLoaded = true;
    //   });
    // },
    getCurrencies() {
      OperationService.getDepositCurrenciesV2().then(response => {
        this.currencies = response.data.data;
        if (!this.$route.query.from) {
          this.selectedCurrency = this.currencies[0].iso;
          this.$router.push({
            query: {
              from: this.currencies[0].iso
            }
          });
        } else {
          this.selectedCurrency = this.$route.query.from;
        }
        this.updateFromCurrency(this.selectedCurrency);
      });
    },
    updateFromCurrency(iso) {
      // this.$refs.networksTabs.callSlider();
      this.loadingFlag = true;
      if (this.$route.query.from !== iso) {
        this.$router.push({ query: { from: iso } });
        this.selectedCurrency = iso;
      }
      this.tab = 0;
      OperationService.getUserNetworkList(iso)
        .then(response => {
          this.networkList = response.data.data;
          this.generateAddress(response.data.data.networks[0]);
        })
        .finally(() => (this.loadingFlag = false));
    },
    confirmWarning() {
      if (this.confirmTagWarning) {
        this.showTagWarningDialog = false;
      }
    }
  }
};
